import { render } from "./abatementCard.vue?vue&type=template&id=67591952&scoped=true"
import script from "./abatementCard.vue?vue&type=script&lang=js"
export * from "./abatementCard.vue?vue&type=script&lang=js"

import "./abatementCard.vue?vue&type=style&index=0&id=67591952&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67591952"]])

export default __exports__